var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderArea"},_vm._l((_vm.buttonsData),function(button){return _c('div',{key:button.id},[_c('button',{staticClass:"orderButton",class:{ selected: _vm.selectedHandler(button.id) },on:{"click":function($event){return _vm.orderClickHandler(button.id)}}},[_vm._v(" "+_vm._s(button.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }